import React from 'react';

export default class Symptom extends React.Component {
  render() {
    return <div className="columns">
      <div className="column"></div>
      <div className="column content">
        Become an active agent in your care by using Engaged Practice to track and manage your symptoms.<br/>
        Share with your care provider involved in your care by using this free access code:
      </div>
      <div className="column"></div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/Symptom.js